var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const callbackMap = new Map();
function kuJiaLeOnMessageReceive() {
  IDP.Miniapp.view.defaultFrame.onMessageReceive(async (data) => {
    const action = data.action;
    const _order = data._order;
    const ret = {
      _order,
      action
    };
    if (action === "Design.getDesignId") {
      Object.assign(ret, {
        value: IDP.Design.getDesignId()
      });
    } else if (action === "Events.on") {
      const value = data.value;
      const callback = (data2) => {
        IDP.Miniapp.view.defaultFrame.postMessage(__spreadProps(__spreadValues({}, ret), { value: data2 }));
      };
      callbackMap.set(_order, callback);
      IDP.Events.on(value[0], callback);
    } else if (action === "Events.off") {
      const value = data.value;
      const callback = callbackMap.get(_order);
      if (callback) {
        callbackMap.delete(_order);
        IDP.Events.off(value[0], callback);
      } else {
        throw new Error("\u8981off\u7684\u4E8B\u4EF6\u4E0D\u5B58\u5728");
      }
    } else if (action === "Events.once") {
      const value = data.value;
      const callback = (data2) => {
        IDP.Miniapp.view.defaultFrame.postMessage(__spreadProps(__spreadValues({}, ret), { value: data2 }));
      };
      IDP.Events.once(value[0], callback);
    } else if (action === "User.getUserId") {
      Object.assign(ret, {
        value: IDP.User.getUserId()
      });
    } else if (action === "User.getAppUidAsync") {
      const value = await IDP.User.getAppUidAsync();
      Object.assign(ret, {
        value
      });
    } else if (action === "Design.getName") {
      Object.assign(ret, {
        value: IDP.Design.getName()
      });
    } else if (action === "Design.save") {
      Object.assign(ret, {
        value: await IDP.Design.save()
      });
    } else if (action === "Custom.Design.CustomModel.findTopModelsAsync") {
      const value = data.value;
      const res = await IDP.Custom.Design.CustomModel.findTopModelsAsync(...value);
      Object.assign(ret, {
        value: res
      });
    } else if (action === "Custom.Detection.detectByModelIdAsync") {
      const value = data.value;
      console.log(`\u8C03\u7528Custom.Detection.detectByModelIdAsync\uFF0C\u53C2\u6570\u4E3A${JSON.stringify(value)}`);
      const res = await IDP.Custom.Detection.detectByModelIdAsync(...value);
      console.log(`Custom.Detection.detectByModelIdAsync\u54CD\u5E94${JSON.stringify(res)}`);
      Object.assign(ret, {
        value: res
      });
    } else if (action === "Custom.Detection.detectAsync") {
      const value = data.value;
      const res = await IDP.Custom.Detection.detectAsync(...value);
      Object.assign(ret, {
        value: res
      });
    } else if (action === "Custom.Design.CustomModel.highlightModels") {
      const value = data.value;
      Object.assign(ret, {
        value: IDP.Custom.Design.CustomModel.highlightModels(...value)
      });
    } else if (action === "Custom.Design.splitDesignByElementsAsync") {
      const value = data.value;
      Object.assign(ret, {
        value: IDP.Custom.Design.splitDesignByElementsAsync(...value)
      });
    }
    IDP.Miniapp.view.defaultFrame.postMessage(ret);
  });
}
export { kuJiaLeOnMessageReceive };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/kuJiaLeOnMessageReceive.js